var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 217.669,
    height: 224.438,
    viewBox: "0 0 217.669 224.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2936",
    d: "M0-682.665H217.669v224.438H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Construction",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2924",
    transform: "translate(56.739 -577.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2926",
    d: "M0,0V35.3",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2928",
    transform: "translate(39.192 -565.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2930",
    d: "M0,0H35",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2932",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2934",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2940",
    transform: "translate(125.438 204.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2942",
    d: "M-110.419,0h28.44a8.112,8.112,0,0,1,7.964,8.206V14.2a2.175,2.175,0,0,1-2.14,2.2h-83.8a2.185,2.185,0,0,1-2.152-2.2V8.206A8.115,8.115,0,0,1-154.131,0h28.27",
    transform: "translate(162.108)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2944",
    transform: "translate(158.109 135.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2946",
    d: "M-46.47,0V39.229H-68.223V0",
    transform: "translate(68.223)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2948",
    transform: "translate(158.109 96.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2950",
    d: "M0-80.093v-39.229",
    transform: "translate(0 119.322)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2952",
    transform: "translate(179.862 96.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2954",
    d: "M0,0V39.229",
    transform: "translate(0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2956",
    transform: "translate(158.109 57.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2958",
    d: "M0-80.093v-39.229",
    transform: "translate(0 119.322)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2960",
    transform: "translate(179.862 57.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2962",
    d: "M0,0V39.229",
    transform: "translate(0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2964",
    transform: "translate(158.109 83.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2966",
    d: "M0,0,21.753,22.992,0,45.984,21.753,68.977,0,91.969",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2968",
    transform: "translate(158.109 37.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2970",
    d: "M0-41.374V-61.639H21.753v20.265",
    transform: "translate(0 61.639)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2972",
    transform: "translate(158.109 37.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2974",
    d: "M0,0,21.753,22.992,0,45.984",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2976",
    transform: "translate(146.643 3.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2978",
    d: "M-4.416,0H36.135A2.1,2.1,0,0,1,38.2,2.127V31.686a2.1,2.1,0,0,1-2.067,2.127H-4.416a2.1,2.1,0,0,1-2.067-2.127V2.127A2.1,2.1,0,0,1-4.416,0Z",
    transform: "translate(6.483)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2980",
    transform: "translate(137.426 9.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2982",
    d: "M0,0H9.217m0,22.379H0",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2984",
    transform: "translate(99.296 31.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2986",
    d: "M-81.457,0h-38.131",
    transform: "translate(119.588)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2988",
    transform: "translate(99.295 9.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2990",
    d: "M0,0H38.131",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2992",
    transform: "translate(51 9.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2994",
    d: "M-103.172-45.691h-45.645a2.453,2.453,0,0,1-2.651-2.151V-65.919a2.444,2.444,0,0,1,2.651-2.152h45.645",
    transform: "translate(151.468 68.071)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2996",
    transform: "translate(124.294 9.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2998",
    d: "M-143.2,0l21.656,21.679m-88.689.7L-187.884,0",
    transform: "translate(210.233)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3000",
    transform: "translate(57.249 9.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3002",
    d: "M0,0,22.348,22.379,44.7,0,67.045,22.379",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3004",
    transform: "translate(72.01 31.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3006",
    d: "M0,0V15.925",
    transform: "translate(0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3008",
    transform: "translate(52.24 62.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3010",
    d: "M-4,0H31.785a1.911,1.911,0,0,1,1.884,1.927V17.3a1.921,1.921,0,0,1-1.884,1.939H-4A1.911,1.911,0,0,1-5.872,17.3V1.927A1.9,1.9,0,0,1-4,0Z",
    transform: "translate(5.872)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3012",
    transform: "translate(58.404 47.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3014",
    d: "M-29.066,0-42.672,14.911",
    transform: "translate(42.672)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3016",
    transform: "translate(72.01 47.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    d: "M0,0,13.606,14.911",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3020",
    transform: "translate(191.327 9.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3022",
    d: "M0,0H19.71a2.439,2.439,0,0,1,2.638,2.152V20.228a2.448,2.448,0,0,1-2.638,2.151H0",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3024",
    transform: "translate(18 157.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3026",
    d: "M-3.377,0H35.776a1.607,1.607,0,0,1,1.568,1.626v13.41a1.6,1.6,0,0,1-1.568,1.626H-3.377a1.609,1.609,0,0,1-1.581-1.626V1.626A1.617,1.617,0,0,1-3.377,0Z",
    transform: "translate(4.957)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3028",
    transform: "translate(39.157 157.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3030",
    d: "M0,0V16.663",
    transform: "translate(0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3032",
    transform: "translate(18 190.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3034",
    d: "M-3.377,0H35.776a1.607,1.607,0,0,1,1.568,1.626v13.41a1.6,1.6,0,0,1-1.568,1.626H-3.377a1.609,1.609,0,0,1-1.581-1.626V1.626A1.617,1.617,0,0,1-3.377,0Z",
    transform: "translate(4.957)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3036",
    transform: "translate(39.157 190.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3038",
    d: "M0,0V16.662",
    transform: "translate(0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3040",
    transform: "translate(3.993 75.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3042",
    d: "M-150.239-224.522v34.088c0,1.126-.681,2.064-1.508,2.064h-67.312c-.839,0-1.508-.938-1.508-2.064V-332.427c0-1.138.669-2.064,1.508-2.064h32.7a.944.944,0,0,1,.961,1.026v64.673h34.07a1.108,1.108,0,0,1,1.094,1.026v27.958",
    transform: "translate(220.567 334.491)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3044",
    transform: "translate(25.198 89.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3046",
    d: "M0,0H12.852",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3048",
    transform: "translate(26.305 108.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3050",
    d: "M0,0H12.852",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3052",
    transform: "translate(140.101 175.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3054",
    d: "M0-60.632V-85.363a4.91,4.91,0,0,1,4.827-4.967H53.938a4.913,4.913,0,0,1,4.84,4.967v24.731",
    transform: "translate(0 90.329)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/Construction.9d34d8b7663d43e43220c1f99bdcddb3.svg";
export { ForwardRef as ReactComponent };